
import React from 'react';
import { Badge } from '@/components/ui/badge';

interface InstancePlanBadgeProps {
  plan: string;
}

const InstancePlanBadge: React.FC<InstancePlanBadgeProps> = ({ plan }) => {
  // Normalize the plan string to lowercase for case-insensitive matching
  const normalizedPlan = plan.toLowerCase();
  
  // Handle business reseller plans
  if (['starter', 'pro', 'expert', 'enterprise'].includes(normalizedPlan)) {
    switch (normalizedPlan) {
      case 'starter':
        return <Badge variant="outline" className="border-green-400">Biz Starter</Badge>;
      case 'pro':
        return <Badge variant="outline" className="border-blue-500">Biz Pro</Badge>;
      case 'expert':
        return <Badge variant="outline" className="border-purple-500">Biz Expert</Badge>;
      case 'enterprise':
        return <Badge variant="outline" className="border-amber-500">Biz Enterprise</Badge>;
      default:
        return <Badge variant="outline">Unknown</Badge>;
    }
  }
  
  // Handle legacy plans (in case there are still references)
  switch (normalizedPlan) {
    case 'free':
      return <Badge variant="outline" className="border-gray-400">Free</Badge>;
    case 'basic':
      return <Badge variant="outline" className="border-blue-400">Basic</Badge>;
    case 'premium':
      return <Badge variant="outline" className="border-purple-400">Premium</Badge>;
    case 'enterprise':
      return <Badge variant="outline" className="border-amber-400">Enterprise</Badge>;
    default:
      // For unknown plans, try to determine if it's a starter/pro/expert/enterprise by name matching
      if (normalizedPlan.includes('start')) {
        return <Badge variant="outline" className="border-green-400">Biz Starter</Badge>;
      } else if (normalizedPlan.includes('pro')) {
        return <Badge variant="outline" className="border-blue-500">Biz Pro</Badge>;
      } else if (normalizedPlan.includes('expert')) {
        return <Badge variant="outline" className="border-purple-500">Biz Expert</Badge>;
      } else if (normalizedPlan.includes('enterprise')) {
        return <Badge variant="outline" className="border-amber-500">Biz Enterprise</Badge>;
      }
      
      // Fallback for truly unknown plans
      return <Badge variant="outline">Biz Plan</Badge>;
  }
};

export default InstancePlanBadge;
